// 메인화면 최상위 컴포넌트 - SearchBar와 ClubPreviewSection이 공유하는 activeTag 상태를 여기서 관리
import React, { useState } from "react";
import SearchBar from "../../components/home/SearchBar";
import LostItemPreviewSection from "../../components/home/LostItemPreviewSection";
import ClubPreviewSection from "../../components/home/ClubPreviewSection";
import "./Home.css"

function Home(){
    // 카테고리 필터 선택 상태: SearchBar(태그 버튼)와 ClubPreviewSection(필터링) 두 자식이 공유
    // 상태를 공통 부모인 Home에 올려(lifting state up) 두 컴포넌트가 같은 값을 참조하게 함
    const [activeTag, setActiveTag] = useState("전체");

    return(
        <>
            <div className="welcome-banner">
              <h2>CampusNow에 오신 것을 환영합니다 !</h2>
              <p>동아리 탐색부터 일정, 분실물, 알림까지 캠퍼스 생활을 한 곳에서 만나보세요!</p>
            </div>
            {/* activeTag: 현재 선택된 카테고리, onTagChange: 태그 변경 시 상태 업데이트 콜백 */}
            <SearchBar activeTag={activeTag} onTagChange={setActiveTag} />
            <LostItemPreviewSection />
            {/* activeTag를 prop으로 전달해 해당 카테고리의 동아리만 필터링 */}
            <ClubPreviewSection activeTag={activeTag} />
        </>
    );
}

export default Home;
